import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Tooltip } from '@flywire/react-headlessui';
import { cx } from '../../utils';
export const useTriggerClasses = ({ className }) => {
    return cx('cursor-default', className);
};
const TriggerComponent = forwardRef(({ className, ...rest }, ref) => {
    const classes = useTriggerClasses({ className });
    return _jsx(Tooltip.Trigger, { className: classes, ref: ref, ...rest });
});
TriggerComponent.displayName = 'Trigger';
const Trigger = TriggerComponent;
export { Trigger };
//# sourceMappingURL=Trigger.js.map